import TaxIncomeSection from '../components/TaxIncomeSection'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { CLIENT_FORM } from 'src/constants/FormNames';
const state = (state) => {
    return({
        clientTaxIncome: getFormValues(CLIENT_FORM)(state).clientTaxIncome || null
    })
}
export default connect(state)(TaxIncomeSection)